import { Button, Checkbox, problemText, TextField } from "@emdur/ui";
import { useState } from "react";
import { call } from "../lib/api";
import type { Org } from "../lib/orgs";

const WORDS = {
  deactivate: { verb: "deactivate", button: "Deactivate", variant: "danger" },
  reactivate: { verb: "restore", button: "Restore", variant: "primary" },
} as const;

/** deactivateOrganization (W6.1, W1.A5) or reactivateOrganization (W6.3), each with a reason and a tick naming the
 * organisation. */
export function ChangeOrganizationState({
  org,
  action,
  run,
  onDone,
}: {
  org: Pick<Org, "id" | "display_name">;
  action: keyof typeof WORDS;
  run: (work: Promise<unknown>) => Promise<void>;
  onDone: (done: Org) => void;
}) {
  const words = WORDS[action];
  const [reason, setReason] = useState("");
  const [sure, setSure] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = () => {
    setBusy(true);
    return run(
      (async () => {
        const r = await call("POST", `/v1/organizations/${org.id}/${action}`, { reason: reason.trim() });
        if (!r.ok) throw new Error(await problemText(r));
        onDone((await r.json()) as Org);
      })(),
    ).finally(() => setBusy(false));
  };
  return (
    <div className="flex flex-col gap-3">
      <TextField label="Reason" value={reason} maxLength={500} onChange={setReason} />
      <Checkbox label={`I want to ${words.verb} ${org.display_name} (${org.id})`} isSelected={sure} onChange={setSure} />
      <div>
        <Button variant={words.variant} onPress={() => void submit()} isDisabled={!reason.trim() || !sure} isLoading={busy}>
          {words.button}
        </Button>
      </div>
    </div>
  );
}

export function DeactivateOrganization(props: Omit<Parameters<typeof ChangeOrganizationState>[0], "action">) {
  return <ChangeOrganizationState {...props} action="deactivate" />;
}

export function RestoreOrganization(props: Omit<Parameters<typeof ChangeOrganizationState>[0], "action">) {
  return <ChangeOrganizationState {...props} action="reactivate" />;
}
